module.exports = __webpack_public_path__ + "img/map-location.45a61ac4.png";